import { type FilterState } from '@calendar/components/calendar-filters';
import { CalendarDaysIcon, ListIcon, StarIcon } from 'lucide-react';

export const DEFAULT_FILTERS: FilterState = {
  season: '2025-26',
  month: null,
  category: undefined,
  freeOnly: false,
  ticketedOnly: false,
  upcomingOnly: true,
  sortBy: 'date-asc',
  view: 'featured',
};

// Seasons
export const SEASONS = [
  { id: '2025-26', name: '2025-26' },
  { id: '2024-25', name: '2024-25' },
  { id: '2023-24', name: '2023-24' },
  { id: '2022-23', name: '2022-23' },
  { id: '2021-22', name: '2021-22' },
  { id: '2020-21', name: '2020-21' },
  { id: '2019-20', name: '2019-20' },
  { id: '2018-19', name: '2018-19' },
  { id: '2017-18', name: '2017-18' },
  { id: '2016-17', name: '2016-17' },
];

// Academic seasons with their corresponding months
export const ACADEMIC_MONTHS = [
  { id: 'jan', name: 'JAN' },
  { id: 'feb', name: 'FEB' },
  { id: 'mar', name: 'MAR' },
  { id: 'apr', name: 'APR' },
  { id: 'may', name: 'MAY' },
  { id: 'jun', name: 'JUN' },
  { id: 'jul', name: 'JUL' },
  { id: 'aug', name: 'AUG' },
  { id: 'sep', name: 'SEP' },
  { id: 'oct', name: 'OCT' },
  { id: 'nov', name: 'NOV' },
  { id: 'dec', name: 'DEC' },
];

// Views
export const VIEWS = [
  { id: 'featured', name: 'Featured', icon: StarIcon },
  { id: 'list', name: 'List', icon: ListIcon },
  { id: 'grid', name: 'Calendar', icon: CalendarDaysIcon },
];

export const URL_PARAM_KEYS = {
  season: 'season',
  month: 'month',
  category: 'category',
  upcomingOnly: 'upcoming',
  freeOnly: 'free',
  ticketedOnly: 'ticketed',
  sortBy: 'sort',
  view: 'view',
} as const;
